import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  return _openBlock(), _createElementBlock("div", {
    class: "d-flex fl-ae fl-jc",
    onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
      return _ctx.showScanQRCodeModal();
    }, ["stop"]))
  }, [_createVNode(_component_SvgIcon, {
    iconContent: _ctx.QRCodeScanSvg,
    iconAlt: _ctx.t('qrcode.icon-alt'),
    iconStyle: _ctx.iconStyle,
    class: "qr-code-scan-button"
  }, null, 8, ["iconContent", "iconAlt", "iconStyle"])]);
}